export { default } from './VideoRendering'
